import { Container, Card, Box, Tab, Alert, IconButton, Button } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import React, { useEffect } from 'react';
import { useAppState, useAuthState, useHttpApi } from 'state';
import Page from 'components/Page';
import { getNotifyColor } from 'helpers/handler';
import DoneIcon from '@mui/icons-material/Done';
import { useWeb3State } from 'state/useWeb3State';
import { useNavigate } from 'react-router-dom';
import DataNotAvailable from 'helpers/DataNotAvailable';
import SubscriptionHead from 'components/subscritiption/SubscriptionHead';

const AllNotifications = () => {
  const [value, setValue] = React.useState('1');
  const navigate = useNavigate();
  const { isAuthorized } = useAuthState();
  const { account } = useWeb3State();
  const { markAllNotificationsAsRead, markNotificationAsRead, markAllNotificationAsReadByAddress } =
    useHttpApi();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { notifications, fetchUserNotifications, readNotification, fetchAllReadNotifications } =
    useAppState();
  useEffect(() => {
    const _fetchData = async () => {
      await fetchAllReadNotifications();
    };
    _fetchData();
  }, [account]);
  return (
    <Page title="All Notifications">
      <SubscriptionHead title="Notifications" />
      <Container sx={{ my: 2 }}>
        <Card>
          <Box sx={{ width: '100%', typography: 'body1', background: `linear-gradient(180deg,  #FFF  10%,#EBEBEB 90%)` }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="read-unread-tabs">
                  <Tab
                    label="Unread"
                    value="1"
                    sx={{ fontWeight: 600, color: '#161c2d', fontSize: '1rem' }}
                  />
                  <Tab
                    label="Read"
                    value="2"
                    sx={{ fontWeight: 600, color: '#161c2d', fontSize: '1rem' }}
                  />
                </TabList>
              </Box>
              <TabPanel value="2">
                {readNotification.length > 0 ? (
                  <Box>
                    {readNotification.map((val) => {
                      return (
                        <Alert
                          sx={{
                            mb: 2
                          }}
                          severity={getNotifyColor(val.notification_criticality)}
                        >
                          {val.body}
                        </Alert>
                      );
                    })}
                  </Box>
                ) : (
                  <DataNotAvailable />
                )}
              </TabPanel>
              <TabPanel value="1">
                {notifications.length > 0 ? (
                  <Box>
                    {notifications.map((val) => {
                      return (
                        <Alert
                          sx={{
                            mb: 2
                          }}
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={async () => {
                                await markNotificationAsRead(val.id, {
                                  address: account
                                });
                                await fetchUserNotifications();
                                await fetchAllReadNotifications();
                              }}
                            >
                              <DoneIcon fontSize="inherit" />
                            </IconButton>
                          }
                          severity={getNotifyColor(val.notification_criticality)}
                        >
                          {val.body}
                        </Alert>
                      );
                    })}
                    <Box display="flex" justifyContent="end">
                      <Button
                        color="error"
                        sx={{ width: '11rem' }}
                        variant="gradient"
                        onClick={async () => {
                          await markAllNotificationAsReadByAddress({
                            xinfin_account_address: account
                          });

                          await fetchUserNotifications();
                          await fetchAllReadNotifications();
                        }}
                      >
                        Mark All As Read
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <DataNotAvailable />
                )}
              </TabPanel>
            </TabContext>
          </Box>
        </Card>
      </Container>
    </Page>
  );
};

export default AllNotifications;
